// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__oTLv9","textAlign":"styles_textAlign__ZbapU","marginTop":"styles_marginTop__qPTxh","marginBottom":"styles_marginBottom__OCUiO"};